<script>
export default {
  name: "top-processing",
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    currencyCellClass(value) {
      if (value < 0) {
        return {
          'text-danger': true,
          'text-end': true,
        }
      }
      return {
        'text-end': true,
      }
    },
  }
}
</script>

<template>
  <b-card
      class="mb-4"
      no-body
  >
    <b-card-body>
      <h3 class="dashboard-card-header mb-4">{{ lodash.startCase($t('performance_dashboards.top_5_processing')) }}</h3>
      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <b-th>No.</b-th>
            <b-th>Pabrik</b-th>
            <b-th class="text-end" style="width: 125px">Tonase (%)</b-th>
            <b-th class="text-end" style="width: 150px">Revenue (Rp)</b-th>
            <b-th class="text-end" style="width: 100px">Margin (Rp)</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-if="data.length">
            <b-tr v-for="(datum, key) in data" :key="datum.id">
              <b-td>{{ key + 1 }}</b-td>
              <b-td style="overflow: hidden;text-overflow: ellipsis;">{{ datum.name }}</b-td>
              <b-td class="text-end">{{ $numeral(datum.percentage_of_total_quantity).format('0,0.00') }}%</b-td>
              <b-td :class="currencyCellClass(datum.revenue)" style="width: 125px">{{ $numeral(datum.revenue).format('$ 0,0.00') }}</b-td>
              <b-td :class="currencyCellClass(datum.net_profit)" style="width: 125px">{{ $numeral(datum.net_profit).format('$ 0,0.00') }}</b-td>
            </b-tr>
          </template>
          <template v-else>
            <b-tr>
              <b-td colspan="5">
                <div class="card shadow-none rounded-0" style="margin: -0.75rem; background-color: #F5F6F7; min-height: 225px; position: relative;">
                  <div
                      style="position: absolute;
                  left: 50%;
                  top: 40%;
                  transform: translate(-50%, -50%);"
                  >
                    <p class="table-status-text pt-4">{{ lodash.upperFirst($t('performance_dashboards.empty_filtered_data_message')) }}</p>
                  </div>
                </div>
              </b-td>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
    </b-card-body>

  </b-card>
</template>

<style lang="scss" scoped>
.table-responsive {
  height: 250px;
}
thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}
</style>